import { tabs } from 'modules/SlotsRoot/data/tabs'
import { tabsLive } from 'modules/SlotsRoot/data/tabsLive'

export const excludeOutcomeList: string[] = []

function getSections(gameList) {
  const sections = gameList.reduce(
    (types, item) => (types.indexOf(item.sectionId) !== -1 ? types : [...types, item.sectionId]),
    [],
  )
  sections.unshift('all')
  return sections
}

function getTab(slotId) {
  const trueTab: string[] = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotId) === -1 ? acc : [...acc, tab]),
    [],
  )
  return trueTab
}

function getTabLive(slotId) {
  const trueTab: string[] = Object.keys(tabsLive).reduce(
    (acc, tab) => (tabsLive[tab].findIndex(item => item === slotId) === -1 ? acc : [...acc, tab]),
    [],
  )

  return trueTab
}

const blackListGames = [
  // amatic
  '54',
  '3',
  '50',
  '74',
  '33',
  '22',
  '24',
  '91',
  '92',
  '37',
  '15',
  '89',
  '72',
  '40',
  '45',
  '25',
  '1501',
  '38',
  '35',
  '77',
  '76',
  '27',
  '55',
  '14',
  '65',
  '17',
  '51',
  '66',
  '10',
  '56',
  '30',
  '79',
  '11',
  '75',
  '94',
  '1502',
  '44',
  '88',
  '12',
  '13',
  '71',
  '47',
  '8',
  '67',
  '86',
  '46',
  '20',
  '28',
  '39',
  '19',
  '23',
  '64',
  '69',
  '9',
  '7',
  '85',
  '1519',
  '78',
  '83',
  '5',
  '90',
  '31',
  '2',
  '4',
  '84',
  // amatic
  'rocketman_elbet'
]

export { getSections, getTab, getTabLive, blackListGames }
